/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Location } from '../../models/location';

export interface FindLocations$Params {
}

export function findLocations(http: HttpClient, rootUrl: string, params?: FindLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Location>>> {
  const rb = new RequestBuilder(rootUrl, findLocations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Location>>;
    })
  );
}

findLocations.PATH = '/api/locations';
